import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IconLayers, IconArrowDown, IconArrowUp, IconList, IconImage } from './sidebarIcons';
import Sidebar from '../components/SidebarNext';
import { hasFunctionAccess } from '../permissionConfig';
import '../Accounts.css';

const NAV_BASE = [
    { to: '/inventory',           label: 'Stock Dashboard', icon: <IconLayers />,    end: true, functionKey: 'stock_dashboard' },
    { to: '/inventory/inward',    label: 'Inward Entry',    icon: <IconArrowDown />, functionKey: 'inward' },
    { to: '/inventory/outward',   label: 'Outward Entry',   icon: <IconArrowUp />,   functionKey: 'outward' },
    { to: '/inventory/sku-desc',  label: 'SKU Master',      icon: <IconList />,      functionKey: 'sku_master' },
    { to: '/inventory/cards',     label: 'Card Inventory',  icon: <IconImage />,     functionKey: 'card_inventory' },
];

// Same Light / Night / Dark switcher as AccountsLayout (Invoicing), sharing
// its saved preference. The sidebar always follows it; the content area only
// does for pages built on the --acc-* theme variables (THEMED_PATHS). The
// other inventory pages still use fixed light colours, so they keep a light
// background instead of rendering dark text on a dark page.
const THEME_KEY = 'acc_theme';
const THEMED_PATHS = ['/inventory/sku-desc'];

export default function InventoryLayout({ user, onLogout, children }) {
    const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || 'normal');
    const location = useLocation();
    const changeTheme = (next) => {
        setTheme(next);
        localStorage.setItem(THEME_KEY, next);
    };
    const themeAttr = theme === 'normal' ? undefined : theme;
    const contentThemed = THEMED_PATHS.some(p => location.pathname.startsWith(p));

    const navItems = NAV_BASE.map(item => ({ ...item, locked: !hasFunctionAccess(user, 'inventory', item.functionKey) }));
    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#FAF8FC' }}>
            {/* display: contents — the wrapper adds no box, but the sidebar
                still inherits the theme's CSS variables from it. */}
            <div data-acc-theme={themeAttr} style={{ display: 'contents' }}>
                <Sidebar navItems={navItems} sectionLabel="Inventory" homeHref="/landing" theme={theme} onThemeChange={changeTheme} user={user} domainKey="inventory" />
            </div>
            <div id="sbn-main" className="sbn-content"
                 data-acc-theme={contentThemed ? themeAttr : undefined}
                 style={{ flex: 1, minWidth: 0, padding: '28px 32px', overflowY: 'auto', height: '100%', background: contentThemed ? 'var(--acc-page-bg, #FAF8FC)' : '#FAF8FC' }}>
                {children}
            </div>
        </div>
    );
}
